module.exports = __webpack_public_path__ + "static/media/nana-happy.afe88158.png";